import React from "react";
import CardView from "../components/CardView";

const Experiences = ({ bg, data }) => {
  return (
    <div
      className={`bg-cover bg-center h-full ${
        bg === "" ? "bg-gradient-to-r from-green-400 to-blue-500" : ""
      }`}
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="pt-10">
        <CardView data={data} />;
      </div>
    </div>
  );
};

export default Experiences;
